import React, { useEffect, useState } from 'react';
import apiClient from '../api/client';
import Modal from '../components/Common/Modal';
import PasswordInput from '../components/Common/PasswordInput';
import { apiError } from './format';
import { Button } from './ui';

const EMPTY = { old_password: '', new_password: '', confirm: '' };

/** Current password, new password, confirm. Used by admins and resellers for their own login. */
const ChangePasswordModal = ({ open, onClose, onDone }) => {
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setForm(EMPTY);
      setError('');
    }
  }, [open]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password.length < 8) return setError('The new password must be at least 8 characters');
    if (form.new_password === form.old_password) return setError('Choose a new password that is different from the current one');
    if (form.new_password !== form.confirm) return setError('The new password and the confirmation do not match');
    setBusy(true);
    setError('');
    try {
      await apiClient.post('/auth/change-password', { old_password: form.old_password, new_password: form.new_password });
      onDone('Password changed');
      onClose();
    } catch (err) {
      setError(apiError(err, 'Could not change your password'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal isOpen={open} title="Change password" onClose={onClose}>
      <form className="ds-form" onSubmit={submit} autoComplete="off">
        {error && <div className="ds-formerror" role="alert">{error}</div>}
        <div className="ds-field">
          <label htmlFor="cp-old">Current password</label>
          <PasswordInput id="cp-old" className="ds-input" required autoComplete="current-password" value={form.old_password} onChange={set('old_password')} />
        </div>
        <div className="ds-field">
          <label htmlFor="cp-new">New password</label>
          <PasswordInput id="cp-new" className="ds-input" required minLength={8} autoComplete="new-password" value={form.new_password} onChange={set('new_password')} />
          <small>At least 8 characters.</small>
        </div>
        <div className="ds-field">
          <label htmlFor="cp-confirm">Confirm new password</label>
          <PasswordInput id="cp-confirm" className="ds-input" required minLength={8} autoComplete="new-password" value={form.confirm} onChange={set('confirm')} />
        </div>
        <div className="ds-modal-actions">
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="primary" type="submit" disabled={busy}>{busy ? 'Saving…' : 'Change password'}</Button>
        </div>
      </form>
    </Modal>
  );
};

export default ChangePasswordModal;
